module.exports = __webpack_public_path__ + "img/suggestion_art.4b20e446.svg";